<template>
  <div class="header-component pcStyle">
    <img src="@/assets/images/autelLogo.png" alt="" />
    <!-- <div class="user-message">{{ userName }}</div> -->
    <div class="border-bottom"></div>
  </div>
</template>
<script>
  export default {
    name: 'Header',
    data() {
      return {
        userName: 'test',
      };
    },
  };
</script>
<style lang="less" scoped>
.header-component.pcStyle {
  height: 64px;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20%;
  position: fixed;
  width: 100%;
  box-sizing: border-box;
  z-index: 9;

  img {
    height: 19px;
  }

  .user-message {
    font-size: 14px;
    color: #fff;
  }

  .border-bottom {
    display: none;
  }
}
</style>